// 1. Import `extendTheme`
import { extendTheme } from "@chakra-ui/react"

// 2. Call `extendTheme` and pass your custom values
const Theme = extendTheme({
  colors: {
    brand:'rgba(6, 194, 149, 1)',
  },
})

export default Theme;
